export const localkey = {
    general: 'nmrpsm-gnrl-sttng',
    button: 'nmrpsm-btn-sttng',
    form: 'nmrpsm-frm-sttng',
	freestyle: 'nmrpsm-frstyl-sttng',
	table: 'nmrpsm-tbl-sttng',
	card: 'nmrpsm-crd-sttng',
	modal: 'nmrpsm-mdl-sttng',
	scroll: 'nmrpsm-scrl-sttng',
	collapse: 'nmrpsm-colps-sttng',
	progress: 'nmrpsm-prgrsbr-sttng',
	navs: 'nmrpsm-navs-sttng',
	dropdown: 'nmrpsm-drpdwn',
}
export const localDefaults = {
	[localkey.general]: {
		color: '#f2f2f2',
		textColor: '#496683',
		textColorIsChange: false,
		lightSource: 'top-left',
	},
	[localkey.button]: {
		distance: 5,
		blur: 10,
		intensity: 40,
		radius: 3,
		convex: false,
	},
	[localkey.form]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		radius: 6,
		border: 2,
		concave: true,
		engrave: false,
	},
	[localkey.freestyle]: {
		distance: 8,
		blur: 16,
		intensity: 40,
		radius: 3, 
		border: 5,
	},
	[localkey.table]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		border: 5,
	},
	[localkey.card]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		radius: 5,
		border: 4,
	},
	[localkey.modal]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		radius: 5, 
		float: true,
	},
	[localkey.scroll]: {
		distance: 2,
		blur: 2,
		intensity: 15,
		radius: 2,  
	},
	[localkey.collapse]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		radius: 5, 
		engrave: true
	},
	[localkey.progress]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		border: 2,
		concave: true,
		engrave: false, 
	},
	[localkey.navs]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		radius: 5,
	},
	[localkey.dropdown]: {
		distance: 4,
		blur: 8,
		intensity: 20,
		radius: 5, 
		float: true,
	},
};